(() => {
  const form = document.querySelector('[data-eom-vip-form]');
  if (!form) return;

  const submit = form.querySelector('[data-eom-vip-submit]');
  const message = form.querySelector('[data-eom-vip-message]');
  const endpoint = '/apps/marketing-app/vip-access/request';

  function setMessage(type, text) {
    message.textContent = text;
    message.className = `eom-vip__message is-active is-${type}`;
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const formData = new FormData(form);
    const payload = {
      name: String(formData.get('name') || '').trim(),
      zip: String(formData.get('zip') || '').trim(),
      email: normalizeEmail(formData.get('email')),
      accepts_marketing: formData.get('accepts_marketing') === 'true',
      source: String(formData.get('source') || 'mailer_qr'),
      campaign: String(formData.get('campaign') || 'soft_launch_vip')
    };

    if (!payload.name || !payload.zip || !payload.email) {
      setMessage('error', 'Please enter your name, ZIP code, and email.');
      return;
    }

    submit.disabled = true;
    submit.textContent = 'Sending...';
    setMessage('success', 'Checking your details...');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || result.ok === false) {
        throw new Error(result.message || 'We could not send your code. Please try again.');
      }

      setMessage(
        'success',
        result.message || 'Your access code is on the way. Check your email to continue.'
      );

      form.reset();
    } catch (error) {
      setMessage('error', error.message || 'Something went wrong. Please try again.');
    } finally {
      submit.disabled = false;
      submit.textContent = 'Send my access code';
    }
  });
})();